(function() {

  const excludedUrls = [
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-pink",
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-red",
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-gun-metal",
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-black",
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-blue",
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-gold",
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-green"
  ];

  if (excludedUrls.some(url => window.location.href.startsWith(url))) return;

  window.addEventListener("load", dartShafts);

  function dartShafts() {
    const optionContainers = document.querySelectorAll('.option-selector');
    let shaftBtnContainer = null;

    optionContainers.forEach(option => {
      const legend = option.querySelector('legend.label');
      if (legend && /Shaft Size/i.test(legend.textContent)) {
        shaftBtnContainer = option.querySelector('.option-selector__btns');
      }
    });

    if (!shaftBtnContainer) return;

    const btnCont = shaftBtnContainer.querySelectorAll('label');
    const shaftCont = document.querySelectorAll('.disclosure__content.rte.product-description div');

    const mmRegex = /(\d+(\.\d+)?)\s*mm/i;
    let mmSizes = [];

    shaftCont.forEach(el => {
      const match = el.textContent.match(mmRegex);
      if (match) mmSizes.push(parseFloat(match[1]));
    });

    if (mmSizes.length === 0) return;

    mmSizes = [...new Set(mmSizes)].sort((a, b) => a - b);

    btnCont.forEach((btn, index) => {
      const size = mmSizes[index];
      if (!size) return;

      const text = btn.textContent.trim();
      if (!text.match(/\(\d+(\.\d+)?mm\)/)) {
        btn.textContent = text + ` (${size}mm)`;
      }
    });
  }
})();
